import useCommonBlogQuery from "@repo/shopifyV2/queries/useBlogQuery";

import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function useBlog(initialVariables?: Record<string, unknown> | null) {
  const { lang } = useLanguage();
  const { openToast } = useLayoutStore();

  return useCommonBlogQuery({
    initialBlogVariables: initialVariables ?? null,
    lang,
    openToast,
  });
}
